import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "identification" }

import router from "@/router";
import { onMounted } from "vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'IdentificationScreen',
  setup(__props) {

onMounted(() => {
  const video = document.getElementById("bg-video") as HTMLVideoElement;
  if (video) {
    video.addEventListener("ended", () => {
      router.push("/worlds");
    });
  }
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("section", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("div", { class: "identification__bg" }, [
      _createElementVNode("video", {
        id: "bg-video",
        src: "/videos/identification.mp4",
        autoplay: "",
        muted: "",
        playsinline: ""
      })
    ], -1)
  ])))
}
}

})